import createAsyncReducer from '../../core/helpers/createAsyncReducer';
import {ROUND_TYPES} from '../../core/constants/actionTypes';

export const distributionReducer = createAsyncReducer(ROUND_TYPES.RX_GET_DISTRIBUTION, {
  rows: [],
});
